import { Alignment, Direction, Displaying, Spacing } from "@bonusx-global/bx-design-system";
import { styled } from "@mui/material";
import Box from "@mui/material/Box";

export const TwoButtonsWarningModalWrapper = styled(Box)({
  display: Displaying.flex,
  flexDirection: Direction.column,
  alignItems: Alignment.center,
  gap: Spacing["1500"],
  padding: `${Spacing["500"]} ${Spacing["0"]}`,
});
